import { Element } from 'chart.js';
import { toFont } from 'chart.js/helpers';
export class WordElement extends Element {
    static computeRotation(o, rnd) {
        if (o.rotationSteps <= 1) {
            return 0;
        }
        if (o.minRotation === o.maxRotation) {
            return o.minRotation;
        }
        const base = Math.min(o.rotationSteps, Math.floor(rnd() * o.rotationSteps)) / (o.rotationSteps - 1);
        const range = o.maxRotation - o.minRotation;
        return o.minRotation + base * range;
    }
    inRange(mouseX, mouseY) {
        const p = this.getProps(['x', 'y', 'width', 'height', 'scale']);
        if (p.scale <= 0) {
            return false;
        }
        const x = Number.isNaN(mouseX) ? p.x : mouseX;
        const y = Number.isNaN(mouseY) ? p.y : mouseY;
        return x >= p.x - p.width / 2 && x <= p.x + p.width / 2 && y >= p.y - p.height / 2 && y <= p.y + p.height / 2;
    }
    inXRange(mouseX) {
        return this.inRange(mouseX, Number.NaN);
    }
    inYRange(mouseY) {
        return this.inRange(Number.NaN, mouseY);
    }
    getCenterPoint() {
        return this.getProps(['x', 'y']);
    }
    tooltipPosition() {
        return this.getCenterPoint();
    }
    draw(ctx) {
        const { options } = this;
        const props = this.getProps(['x', 'y', 'width', 'height', 'text', 'scale']);
        if (props.scale <= 0) {
            return;
        }
        ctx.save();
        const f = toFont({ ...options, size: options.size * props.scale });
        ctx.font = f.string;
        ctx.fillStyle = options.color;
        ctx.textAlign = 'center';
        ctx.translate(props.x, props.y);
        ctx.rotate((options.rotate / 180) * Math.PI);
        if (options.strokeStyle) {
            if (options.strokeWidth != null) {
                ctx.lineWidth = options.strokeWidth;
            }
            ctx.strokeStyle = options.strokeStyle;
            ctx.strokeText(props.text, 0, 0);
        }
        ctx.fillText(props.text, 0, 0);
        ctx.restore();
    }
}
WordElement.id = 'word';
WordElement.defaults = {
    minRotation: -90,
    maxRotation: 0,
    rotationSteps: 2,
    padding: 1,
    strokeStyle: undefined,
    strokeWidth: undefined,
    size: (ctx) => {
        const v = ctx.parsed.y;
        return v;
    },
    hoverColor: '#ababab',
};
WordElement.defaultRoutes = {
    color: 'color',
    family: 'font.family',
    style: 'font.style',
    weight: 'font.weight',
    lineHeight: 'font.lineHeight',
};
//# sourceMappingURL=WordElement.js.map